import * as echarts from 'echarts'

export default {
    //辅助决策——预测数据图表
    getTargetChart(container, echartsData) {
        echarts.dispose(document.getElementById(container))
        let myChart = echarts.init(document.getElementById(container));
        let unit = echartsData?.unit ?? ''
        let option = {
            tooltip: {
                trigger: 'axis',
                formatter: "{a} <br/>{b}: {c}" + unit,
                transitionDuration: 0
            },
            grid: {
                top: '10%',
                left: '5%',
                right: '0%',
                bottom: '15%',
                // containLabel: true
            },
            legend: {
                show: true
            },
            xAxis: [{
                type: 'category',
                axisLabel: {
                    show: true,
                    textStyle: {
                        color: '#666',
                        fontSize: 12
                    }
                    // formatter: '{value} 台'
                },
                axisTick: {
                    show: false,
                },
                splitLine: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: '#eee',
                    }
                },
                // boundaryGap: false,
                data: echartsData.yearList,

            }],

            yAxis: [{
                name: "单位：" + echartsData.unit || '--',
                type: 'value',
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#eee'
                    }
                },
                axisLine: {
                    show: false,
                },
                axisLabel: {
                    show: true,
                    textStyle: {
                        color: '#666',
                        fontSize: 12
                    }
                    // formatter: '{value} 台'
                },
                axisTick: {
                    show: false,
                },

            }],
            series: [{
                name: '实际数据',
                type: 'line',
                smooth: true,
                symbolSize: 6,
                itemStyle: {
                    normal: {
                        color: "#F5C228",
                    },
                },
                data: echartsData.realList
            },
            {
                name: '预测数据',
                type: 'line',
                smooth: true,
                symbolSize: 6,
                itemStyle: {
                    normal: {
                        color: "#62D9AA",
                    },
                },

                data: echartsData.forecastList
            }
            ]
        };
        myChart.setOption(option);
        return myChart;

    },

    // 生产分析
    ProductAnalysisChart(container, echartsData) {
        echarts.dispose(document.getElementById(container))
        let myChart = echarts.init(document.getElementById(container));
        let unit = echartsData?.unit ?? ''
        let option = {
            tooltip: {
                trigger: 'axis',
                formatter: "{a} <br/>{b}年: {c}" + unit,
                transitionDuration: 0
            },
            grid: {
                top: '10%',
       
                right: '0%',
                bottom: '15%',
                // containLabel: true
            },
            legend: {
                show: true
            },
            xAxis: [{
                type: 'category',
                axisLabel: {
                    show: true,
                    textStyle: {
                        color: '#666',
                        fontSize: 12
                    }
                    // formatter: '{value} 台'
                },
                axisTick: {
                    show: false,
                },
                splitLine: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: '#eee',
                    }
                },
                inverse: echartsData?.inverse ?? false, //正序倒序 -1是跟返回数据相反的顺序 不设置时是默认顺序
                // boundaryGap: false,
                data: echartsData.xList,

            }],

            yAxis: [{
                name: "单位：" + echartsData.unit || '--',
                type: 'value',
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#eee'
                    }
                },
                axisLine: {
                    show: false,
                },
                axisLabel: {
                    show: true,
                    textStyle: {
                        color: '#666',
                        fontSize: 12
                    }
                    // formatter: '{value} 台'
                },
                axisTick: {
                    show: false,
                },

            }],
            series: [{
                name: echartsData.name,
                type: 'bar',
                smooth: true,
                symbolSize: 6,
                barWidth: 30,
                emphasis: {
                    barBorderRadius: 30
                },
                itemStyle: {
                    normal: {
                        barBorderRadius:30,
                        // color: "#00ab4b",
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: '#a1dc61' }, // 底部柱图渐变色
                            { offset: 1, color: '#00ab4b' } // 顶部柱图渐变色
                        ])
                    },
                },
                data: echartsData.yList
            },
            ]
        };
        myChart.setOption(option);
        return myChart;

    },



}